export default "__VITE_ASSET__d5786eb5__"